


























































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Actions, Mutations, Endpoints, ViewModes, MessageActionTypes } from '@/ts/store/Constants';
import MessageData from '@/ts/MessageData';
import RemoteImage from '@/components/Media/RemoteImage.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import FullScreenImageViewer from '@/components/Media/FullScreenImageViewer.vue';
import Axios from 'axios';

import { Filesystem, Directory } from '@capacitor/filesystem';
import write_blob from 'capacitor-blob-writer';

@Component({
    components: {
        RemoteImage,
        FullScreenImageViewer,
    },
})
export default class Message extends Mixins(DeviceMethods) {
    @Prop() public messageData!: MessageData;

    public classes: { [index: string]: {} } = {
        'hococo-feed-message__us': !this.messageData.isAction && (this.messageData.bySelf || this.currentUserId === this.messageData.authorId),
        'hococo-feed-message__them': !this.messageData.isAction && (!this.messageData.bySelf && this.currentUserId !== this.messageData.authorId),
        'hococo-feed-message__staff': !this.messageData.isAction && !this.messageData.bySelf && this.byStaff,
        'hococo-feed-message__action': this.messageData.isAction,
        'hococo-feed-message--has-image': (this.messageData.attachmentGUID),
        'hococo-feed-message__highlighted': this.shouldBeHighlighted,
    };

    constructor() {
        super();
    }

    get currentUserId() {
        return this.$store.getters['User/getUserId'];
    }

    public fullScreenImageViewer(guid: string) {
        this.$store.commit(Mutations.ADD_ACTIVE_FULLSCREEN_IMAGE, guid);
        this.$store.commit(Mutations.IS_FULLSCREEN, true);
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get messagesMode() {
        return (this.view.viewMode === ViewModes.Messages.Messages);
    }

    get senderImage() {

        if (this.sender !== null && typeof this.sender !== 'undefined') {

            if (this.sender.fetchedMiniature === false) {
                this.sender.fetchMiniature(this.$store);
                this.sender.fetchedMiniature = true;
            }

            if (this.sender.hasMiniature || this.sender.hasProfileImage) {

                if (this.sender.hasMiniature) {
                    return this.sender.miniatureImage;
                }

                if (this.sender.hasProfileImage) {
                    return this.sender.profileImage;
                }
            }
        }

        return null;
    }

    get sender() {
        return this.$store.getters['User/getCacheUser'](this.messageData.authorId);
    }

    get byStaff() {
        if (this.sender === null || this.sender !== 'undefined') {
            return false;
        }

        return typeof this.$store.getters['User/getCacheRole'](this.sender.roleId) !== 'undefined'
            ? this.$store.getters['User/getCacheRole'](this.sender.roleId).isStaff
            : false;
    }

    get actionMessage() {
        if (!this.messageData || this.messageData.actionType === null) {
            return '';
        }

        const author = this.$store.getters['User/getCacheUser'](this.messageData.authorId);
        const target = this.$store.getters['User/getCacheUser'](this.messageData.actionTarget);

        switch (this.messageData.actionType) {
            case MessageActionTypes.ADD_PARTICIPANT:
                return author.firstName + ' added ' + target.firstName + ' to the conversation';

            case MessageActionTypes.REMOVE_PARTICIPANT:
                return author.firstName + ' removed ' + target.firstName + ' from the conversation';

            default:
                return '';
        }
    }

    get searchTerm() {
        return this.$store.state.Messages.conversationSearchTerm;
    }

    get isSearching() {
        return this.$store.state.vuexSearch.messages.isSearching;
    }

    public previewPdf(id: number) {
        this.device().then((deviceInfo) => {
            if (deviceInfo.platform === 'ios' || deviceInfo.platform === 'android') {
                Axios.get(Endpoints.Conversations.CONVERSATION_DOWNLOAD_PDF(id), { responseType: 'blob' })
                    .then(async (response) => {
                        const blob = new Blob([response.data], {type: 'application/pdf'});
                        const fileName = 'hoc-document-' + id + '.pdf';

                        const directory = (deviceInfo.platform === 'ios')
                            ? Directory.Documents
                            : Directory.Data;

                        const uri = await write_blob({
                            path: fileName,
                            directory,
                            blob,
                            recursive: true,
                            on_fallback: (writeError) => { 
                                console.log('Error Writing: ' + writeError); 
                            },
                        });

                        (window as any).cordova.plugins.fileOpener2.open(
                            uri,
                            'application/pdf',
                            {
                                error : () => {},
                                success : () => {},
                            },
                        );
                    });
            } else {
                this.$store.dispatch(Actions.FETCH_CONVERSATION_PDF_PREVIEW, id);
            }
        });
    }

    @Watch('isSearching')
    public searchWatcher() {
        if (this.isSearching === false) {
            this.evaluateMessageClasses();
        }
    }

    public evaluateMessageClasses() {
        this.classes = {
            'hococo-feed-message__us': !this.messageData.isAction && this.messageData.bySelf,
            'hococo-feed-message__them': !this.messageData.isAction && !this.messageData.bySelf,
            'hococo-feed-message__staff': !this.messageData.isAction && !this.messageData.bySelf && this.byStaff,
            'hococo-feed-message__action': this.messageData.isAction,
            'hococo-feed-message__highlighted': this.shouldBeHighlighted,
        };
    }

    get shouldBeHighlighted() {
        if (this.messageData.isAction) {
            return false;
        }

        if (this.$store.getters['vuexSearch/@@vuexSearch/getter/isSearching']('messages') === true) {
            return false;
        }

        if (this.$store.state.Messages.conversationSearchTerm === '') {
            return false;
        }

        const searchResults = this.$store.getters['vuexSearch/@@vuexSearch/getter/result']('messages');

        return searchResults.includes(this.messageData.id);
    }

    public messageTime() {
        const time    = this.$options.filters.moment(this.messageData.time, 'hh:mm A');
        const isToday = this.messageData.time.isSame(Date.now(), 'day');

        return (isToday === true)
            ? `Today - ${time}`
            : this.$options.filters.moment(this.messageData.time, 'DD-MM-YYYY - hh:mm A');
    }
}
